import EsmModal from './EsmModal';
import EDate from './EDate.vue';
import EEllipsis from './EEllipsis.vue';
import EEditor from './EEditor.vue';
import EsmEasyCron from "@/components/esm/EsmEasyCron";

export default {
    install(Vue) {
        Vue.use(EsmModal)

        Vue.component('EDate', EDate)
        Vue.component('EEllipsis', EEllipsis)
        Vue.component('EEditor', EEditor)

        Vue.component(EsmEasyCron.name, EsmEasyCron)

    }
}
